import { Public } from 'modules/router/types';

import {
  ROUTE_LANDING_PAGES_CLICKFUNNELS,
  ROUTE_LANDING_PAGES_CLICKFUNNELS_UPSELL,
  ROUTE_LANDING_PAGES_CONGRATS,
} from './constants';

import { ClickFunnels, Congrats } from '../pages';
import { IsFeatureVisible } from '../../dashboard/utils/isAdminCustomer';

export const routes = IsFeatureVisible('FEATURE_LANDING_PAGES')
  ? [
    {
      type: Public,
      path: ROUTE_LANDING_PAGES_CLICKFUNNELS,
      component: ClickFunnels,
      exact: true,
    },
    // The ClickFunnels upsell charged the member's Chargify payment profile.
    // The Chargify account is cancelled, so the upsell step is retired and its
    // URL goes straight to the congrats step, as "No thanks" did
    // (hubspot-off-block-3 task 96).
    {
      path: ROUTE_LANDING_PAGES_CLICKFUNNELS_UPSELL,
      redirect: ROUTE_LANDING_PAGES_CONGRATS,
    },
    {
      type: Public,
      path: ROUTE_LANDING_PAGES_CONGRATS,
      component: Congrats,
      exact: true,
    },
  ]
  : [];
